import { Box, BoxProps } from '@amzn/awsui-components-core';
import { ContentRequestState, UserProfile } from '@amzn/awscat-pattern-library-service-model';
import React, { useEffect } from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import { ContentRequestAssignmentTableColumns } from './ContentRequestColumnDefinition';
import ContentRequestTable from './ContentRequestTable';

interface ContentRequestsTableProps {
  userProfile: UserProfile;
  wrapperPadding?: BoxProps.Spacing;
}

const mplServiceClient: IMplServiceClient = MplServiceClientFactory.create();

const contentRequestDisplayState = [ContentRequestState.ASSIGNED, ContentRequestState.ACCEPTED];

const ContentRequestAssignmentTable = ({
  userProfile,
  wrapperPadding,
}: ContentRequestsTableProps) => {
  const [contentRequests, setContentRequests] = React.useState([]);
  const [isLoading, setLoadingState] = React.useState(false);

  const fetchSuggestions = async () => {
    const { userId } = userProfile;
    setLoadingState(true);
    const listsOfContentRequest = await mplServiceClient.listContentRequestsForAssignee(userId);
    setContentRequests(
      // @ts-expect-error TS7006 - strict migration
      listsOfContentRequest.contentRequests.filter((cr) =>
        contentRequestDisplayState.includes(cr.state),
      ),
    );
    setLoadingState(false);
  };

  useEffect(() => {
    fetchSuggestions();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box padding={wrapperPadding}>
      <ContentRequestTable
        headerText={constants.CONTENT_REQUEST_ASSIGNMENT_TABLE_HEADER}
        tableId={WorkflowTableIdentity.ContentRequestsAssignmentTable}
        contentRequests={contentRequests}
        columnDefinitions={ContentRequestAssignmentTableColumns}
        loading={isLoading}
        onRefreshClick={fetchSuggestions}
      />
    </Box>
  );
};

export default ContentRequestAssignmentTable;
